var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpo2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FFA500",
    fillOpacity: 0.21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8831 27.1392C17.5553 27.1392 17.2807 27.0281 17.0593 26.806C16.8379 26.5839 16.7269 26.3093 16.7261 25.9822V21.3543C16.7261 21.0265 16.8372 20.7519 17.0593 20.5305C17.2815 20.3091 17.556 20.1981 17.8831 20.1973H20.7755C21.1034 20.1973 21.3783 20.3084 21.6005 20.5305C21.8226 20.7527 21.9333 21.0272 21.9325 21.3543V25.9822C21.9325 26.31 21.8215 26.585 21.5993 26.8072C21.3772 27.0293 21.1026 27.14 20.7755 27.1392H17.8831ZM18.4616 25.4037H20.1971V21.9328H18.4616V25.4037ZM23.668 29.4532V26.2715C23.668 25.9437 23.7791 25.6691 24.0012 25.4477C24.2234 25.2263 24.498 25.1153 24.825 25.1145H27.139V24.2467H23.668V22.5113H27.7175C28.0453 22.5113 28.3202 22.6223 28.5424 22.8445C28.7645 23.0666 28.8752 23.3412 28.8744 23.6683V25.693C28.8744 26.0208 28.7634 26.2958 28.5412 26.5179C28.3191 26.74 28.0445 26.8507 27.7175 26.85H25.4035V27.7177H28.8744V29.4532H23.668ZM14.4121 29.3953C12.0403 29.1254 10.0973 28.1084 8.58324 26.3444C7.06913 24.5803 6.31246 22.4542 6.31323 19.9659C6.31323 18.0376 7.07993 15.9407 8.61332 13.6754C10.1467 11.41 12.4653 8.95603 15.5691 6.31348C18.1145 8.47318 20.1346 10.5172 21.6294 12.4455C23.1242 14.3738 24.093 16.1864 24.5358 17.8833H22.135C21.7108 16.6685 20.9491 15.3476 19.85 13.9207C18.7508 12.4937 17.3239 10.98 15.5691 9.37949C13.2744 11.4813 11.544 13.4193 10.3777 15.1933C9.21148 16.9674 8.62797 18.5582 8.6272 19.9659C8.6272 21.8171 9.1625 23.3937 10.2331 24.6957C11.3037 25.9977 12.6967 26.7832 14.4121 27.0524V29.3953Z",
    fill: "#FFA500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpo2);
export default __webpack_public_path__ + "static/media/SPO2.e4596d7330dee0d46b3bc25ed8000e02.svg";
export { ForwardRef as ReactComponent };